import React, { Component } from 'react';
import noScroll from 'no-scroll';

let lockedElementsCount = 0;

/**
 * Higher order component to add scroll lock to body.
 * @param {String} scrollLockProperty   Property of Wrapped component which will enable scrollLock.
 */
const ScrollLockHOCFactory = (scrollLockProperty) => { // eslint-disable-line
    /**
     * @param {Object} WrappedComponent     React Component
     */

    scrollLockProperty = scrollLockProperty || 'scrollLock';

    return function Factory(WrappedComponent) {
        return class ScrollLockHOC extends Component { // eslint-disable-line
            constructor() {
                super();
                this.lockScroll = this.lockScroll.bind(this);
                this.releaseScroll = this.releaseScroll.bind(this);
            }

            componentDidMount() {
                if (this.props[scrollLockProperty]) {
                    this.lockScroll();
                }
            }

            componentDidUpdate(prevProps) {
                if (prevProps[scrollLockProperty] !== this.props[scrollLockProperty]) {
                    if (this.props[scrollLockProperty]) {
                        this.lockScroll();
                    } else {
                        this.releaseScroll();
                    }
                }
            }

            componentWillUnmount() {
                if (this.props[scrollLockProperty]) {
                    this.releaseScroll();
                }
            }

            lockScroll() {
                const { deviceType, enablePageScroll = false } = this.props; // eslint-disable-line react/prop-types
                if (
                    deviceType &&
                    (deviceType.isMobile || deviceType.isTablet) &&
                    !enablePageScroll
                ) {
                    noScroll.on();
                    document.querySelector('html').style.overflow = '';
                } else {
                    document && document.body.classList.add('hidden-overflow');
                }
                lockedElementsCount += 1;
            }

            releaseScroll() {
                if (lockedElementsCount > 0) {
                    lockedElementsCount -= 1;
                }

                // #TJ do not release scroll when there's at least 1 element that needs scroll-lock
                if (!lockedElementsCount) {
                    const deviceType = this.props.deviceType; // eslint-disable-line
                    if (deviceType && (deviceType.isMobile || deviceType.isTablet)) {
                        noScroll.off();
                    }
                    // safe to remove class in both cases
                    document && document.body.classList.remove('hidden-overflow');
                }
            }

            render() {
                const props = { ...this.props };
                return <WrappedComponent {...props} />;
            }
        };
    };
};

export default ScrollLockHOCFactory;
